import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const F1CarImg = () => (
  <img
    src="/f1-car.png"
    alt="F1 car"
    style={{ width: 560, height: 'auto', display: 'block' }}
    draggable={false}
  />
);

const PageTransition = () => {
  const location = useLocation();
  const prevPathRef = useRef(null);
  const [active, setActive] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (prevPathRef.current !== null && prevPathRef.current !== location.pathname) {
      clearTimeout(timerRef.current);
      setActive(true);
      timerRef.current = setTimeout(() => setActive(false), 1300);
    }
    prevPathRef.current = location.pathname;
    return () => clearTimeout(timerRef.current);
  }, [location.pathname]);

  if (!active) return null;

  return (
    <>
      <style>{`
        @keyframes f1-car-zoom {
          0%   { transform: translateX(-620px); opacity: 0; }
          10%  { opacity: 1; }
          88%  { opacity: 1; }
          100% { transform: translateX(calc(100vw + 620px)); opacity: 0; }
        }
        @keyframes f1-streak {
          0%   { transform: scaleX(0) translateX(-100%); opacity: 0; }
          20%  { opacity: 1; }
          80%  { opacity: 0.6; }
          100% { transform: scaleX(1) translateX(0); opacity: 0; }
        }
        @keyframes f1-flash {
          0%   { opacity: 0; }
          15%  { opacity: 0.08; }
          100% { opacity: 0; }
        }
        @keyframes f1-streak-fast {
          0%   { width: 0; opacity: 0.8; }
          60%  { opacity: 0.5; }
          100% { width: 100vw; opacity: 0; }
        }
      `}</style>

      <div className="fixed inset-0 pointer-events-none overflow-hidden"
        style={{ zIndex: 99999 }}>

        {/* Screen flash */}
        <div className="absolute inset-0"
          style={{ background: 'linear-gradient(90deg,transparent 30%,#e1060018 60%,transparent 100%)',
            animation: 'f1-flash 0.9s ease forwards' }} />

        {/* Speed streaks — left side */}
        {[
          { top: '35%', width: '55%', delay: '0ms',   height: 1.5, opacity: 0.18 },
          { top: '42%', width: '70%', delay: '30ms',  height: 1,   opacity: 0.12 },
          { top: '48%', width: '80%', delay: '10ms',  height: 2,   opacity: 0.22 },
          { top: '53%', width: '65%', delay: '50ms',  height: 1,   opacity: 0.15 },
          { top: '58%', width: '50%', delay: '20ms',  height: 1.5, opacity: 0.1  },
        ].map((s, i) => (
          <div key={i}
            style={{
              position: 'absolute',
              top: s.top,
              left: 0,
              height: s.height,
              background: `linear-gradient(90deg, transparent, #e10600 40%, #fff 60%, transparent)`,
              opacity: s.opacity,
              animation: `f1-streak-fast 0.75s ${s.delay} ease-out forwards`,
            }}
          />
        ))}

        {/* F1 Car */}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: 0,
            transform: 'translateY(-50%)',
            animation: 'f1-car-zoom 1.15s cubic-bezier(0.3, 0, 0.2, 1) forwards',
            filter: 'drop-shadow(0 0 12px #e10600aa) drop-shadow(4px 0 8px #e1060066)',
          }}>
          <F1CarImg />
        </div>

        {/* Ground shadow */}
        <div
          style={{
            position: 'absolute',
            top: 'calc(50% + 22px)',
            left: 0,
            width: 180,
            height: 8,
            borderRadius: '50%',
            background: 'radial-gradient(ellipse, rgba(225,6,0,0.3) 0%, transparent 70%)',
            animation: 'f1-car-zoom 1.15s cubic-bezier(0.3, 0, 0.2, 1) forwards',
            filter: 'blur(4px)',
          }}
        />
      </div>
    </>
  );
};

export default PageTransition;
